var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMarketing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 80,
    viewBox: "0 0 82 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.62012 40C1.62012 62.09 19.5201 80 41.6101 80.01C63.7001 80.01 81.6101 62.11 81.6201 40.02C81.6201 17.91 63.7101 0 41.6201 0C19.5301 0 1.62012 17.91 1.62012 40Z",
    fill: "#E0E9FD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.29 41.5997C12.29 58.5397 26.01 72.2697 42.94 72.2797C59.88 72.2797 73.61 58.5597 73.62 41.6197V41.5997C73.62 24.6597 59.9 10.9297 42.96 10.9297C26.02 10.9297 12.29 24.6497 12.29 41.5897C12.29 41.5897 12.29 41.5897 12.29 41.5997Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M42.96 62.2704C31.55 62.2704 22.29 53.0204 22.29 41.6104C22.29 30.2004 31.54 20.9404 42.95 20.9404C54.36 20.9404 63.62 30.1904 63.62 41.6004C63.61 53.0104 54.36 62.2604 42.96 62.2704Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M78.5898 37.7799C78.5898 38.2599 78.2098 38.6399 77.7298 38.6399H66.1598C65.6798 38.6399 65.2998 38.2499 65.2998 37.7799V23.9899C65.2998 23.5099 65.6898 23.1299 66.1598 23.1299H74.1598L78.5898 27.5599V37.7799Z",
    fill: "white",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M74.1602 23.1299V27.5599H78.5901L74.1602 23.1299Z",
    fill: "#2B6BF3",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M67.4902 31.1904H75.9802",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M67.4902 33.4102H75.9802",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M67.4902 35.6201H75.9802",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M67.4902 28.9805H71.9202",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M44.4302 4.53967C44.1202 4.34967 43.7402 4.35967 43.4402 4.56967C43.1302 4.78967 42.9502 5.15967 42.9502 5.53967V15.0797C42.9502 15.4697 43.1302 15.8297 43.4402 16.0497C43.7402 16.2497 44.1202 16.2697 44.4302 16.0797L52.3402 11.3097C52.8902 10.9397 53.0402 10.1797 52.6602 9.62967C52.5702 9.49967 52.4602 9.38967 52.3402 9.30967L44.4302 4.53967Z",
    fill: "#2B6BF3"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M44.4302 4.53967C44.1202 4.34967 43.7402 4.35967 43.4402 4.56967C43.1302 4.78967 42.9502 5.15967 42.9502 5.53967V15.0797C42.9502 15.4697 43.1302 15.8297 43.4402 16.0497C43.7402 16.2497 44.1202 16.2697 44.4302 16.0797L52.3402 11.3097C52.8902 10.9397 53.0402 10.1797 52.6602 9.62967C52.5702 9.49967 52.4602 9.38967 52.3402 9.30967L44.4302 4.53967Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M46.7199 54.6798C47.0699 55.7398 46.4999 56.8798 45.4499 57.2298C44.9399 57.3998 44.3899 57.3598 43.9099 57.1198L38.1299 54.2298C34.7499 52.5398 30.9599 51.8298 27.1999 52.1898L7.1799 54.8298C3.9399 55.2598 0.969901 52.9798 0.549901 49.7398C0.219901 47.2098 1.5499 44.7498 3.8499 43.6398L20.7099 35.5198C24.5299 33.5598 27.6199 30.4398 29.5399 26.5998L32.0599 21.5498C32.5599 20.5498 33.7699 20.1498 34.7699 20.6498C35.2499 20.8898 35.6099 21.3098 35.7799 21.8198L46.7199 54.6798Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5899 64.2803C21.2699 66.2903 20.1999 68.4704 18.1899 69.1504C16.9599 69.5704 15.6099 69.3404 14.5899 68.5404L13.6199 67.8004C12.9399 67.2704 12.4299 66.5503 12.1499 65.7403L8.43994 54.6703L14.5599 53.8604L16.4399 59.4604C16.8099 60.5904 17.6199 61.5204 18.6799 62.0504C19.5899 62.5104 20.2799 63.3103 20.5899 64.2803Z",
    fill: "#2B6BF3"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M45.3696 33.1504C47.4296 33.1504 49.0996 34.8204 49.0996 36.8804C49.0996 38.0504 48.5496 39.1604 47.6096 39.8604L42.9596 43.3504L39.5596 33.1504H45.3796H45.3696Z",
    fill: "#FFF5E3"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M46.7199 54.6798C47.0699 55.7398 46.4999 56.8798 45.4499 57.2298C44.9399 57.3998 44.3899 57.3598 43.9099 57.1198L38.1299 54.2298C34.7499 52.5398 30.9599 51.8298 27.1999 52.1898L7.1799 54.8298C3.9399 55.2598 0.969901 52.9798 0.549901 49.7398C0.219901 47.2098 1.5499 44.7498 3.8499 43.6398L20.7099 35.5198C24.5299 33.5598 27.6199 30.4398 29.5399 26.5998L32.0599 21.5498C32.5599 20.5498 33.7699 20.1498 34.7699 20.6498C35.2499 20.8898 35.6099 21.3098 35.7799 21.8198L46.7199 54.6798Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M45.3696 33.1504C47.4296 33.1504 49.0996 34.8204 49.0996 36.8804C49.0996 38.0504 48.5496 39.1604 47.6096 39.8604L42.9596 43.3504L39.5596 33.1504H45.3796H45.3696Z",
    fill: "white",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5601 53.8601L16.0901 58.4301L18.2101 57.7401C19.0901 57.4501 19.5701 56.5101 19.2901 55.6301L18.5401 53.3301L14.5601 53.8601Z",
    fill: "#2B6BF3",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6699 53.05L7.1799 54.83C3.9399 55.26 0.969901 52.98 0.549901 49.74C0.219901 47.21 1.5499 44.75 3.8499 43.64L15.6499 37.96L20.6699 53.05Z",
    fill: "#2B6BF3"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6699 53.05L7.1799 54.83C3.9399 55.26 0.969901 52.98 0.549901 49.74C0.219901 47.21 1.5499 44.75 3.8499 43.64L15.6499 37.96L20.6699 53.05Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5899 64.2803C21.2699 66.2903 20.1999 68.4704 18.1899 69.1504C16.9599 69.5704 15.6099 69.3404 14.5899 68.5404L13.6199 67.8004C12.9399 67.2704 12.4299 66.5503 12.1499 65.7403L8.43994 54.6703L14.5599 53.8604L16.4399 59.4604C16.8099 60.5904 17.6199 61.5204 18.6799 62.0504C19.5899 62.5104 20.2799 63.3103 20.5899 64.2803Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3999 45.4902L13.4499 48.6802",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M7.60986 47.0596L8.65986 50.2496",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M59.9599 58.0303C59.3899 58.0303 58.9199 57.5603 58.9199 56.9903V54.2903L61.3999 52.5703L67.3799 58.0203C67.3799 58.0203 67.3199 58.0203 67.2799 58.0203H59.9599V58.0303Z",
    fill: "#2B6BF3"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M68.3199 49.6701V56.9901C68.3199 57.0801 68.2999 57.1701 68.2799 57.2501L61.8399 51.3801C61.6399 51.1901 61.3299 51.1801 61.1099 51.3301L58.9199 52.8501V49.6601C58.9199 49.0901 59.3899 48.6201 59.9599 48.6201H67.2799C67.8499 48.6201 68.3199 49.0901 68.3199 49.6601V49.6701Z",
    fill: "#2B6BF3"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M71.2597 45.1104H68.7697C68.4497 45.1104 68.1797 45.3704 68.1797 45.7004C68.1797 46.0304 68.4397 46.2904 68.7697 46.2904H70.6697V48.1804C70.6697 48.5004 70.9297 48.7704 71.2597 48.7704C71.5897 48.7704 71.8497 48.5104 71.8497 48.1804V45.7004C71.8497 45.3804 71.5897 45.1104 71.2597 45.1104Z",
    fill: "black"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M55.9796 48.7596C56.2996 48.7596 56.5696 48.4996 56.5696 48.1696V46.2796H58.4496C58.7696 46.2796 59.0396 46.0196 59.0396 45.6896C59.0396 45.3596 58.7796 45.0996 58.4496 45.0996H55.9796C55.6596 45.0996 55.3896 45.3596 55.3896 45.6896V48.1696C55.3896 48.4896 55.6496 48.7596 55.9796 48.7596Z",
    fill: "black"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M71.2597 57.9102C70.9397 57.9102 70.6697 58.1702 70.6697 58.5002V60.3902H68.7697C68.4497 60.3902 68.1797 60.6502 68.1797 60.9802C68.1797 61.3102 68.4397 61.5702 68.7697 61.5702H71.2597C71.5797 61.5702 71.8497 61.3102 71.8497 60.9802V58.5002C71.8497 58.1802 71.5897 57.9102 71.2597 57.9102Z",
    fill: "black"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M55.9796 61.5604H58.4496C58.7696 61.5604 59.0396 61.3004 59.0396 60.9704C59.0396 60.6404 58.7796 60.3804 58.4496 60.3804H56.5696V58.4904C56.5696 58.1704 56.3096 57.9004 55.9796 57.9004C55.6496 57.9004 55.3896 58.1604 55.3896 58.4904V60.9704C55.3896 61.2904 55.6496 61.5604 55.9796 61.5604Z",
    fill: "black"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M57.7402 49.67V56.99C57.7402 58.21 58.7302 59.2 59.9502 59.2H67.2702C68.4902 59.2 69.4802 58.21 69.4802 56.99V49.67C69.4802 48.45 68.4902 47.46 67.2702 47.46H59.9502C58.7302 47.46 57.7402 48.45 57.7402 49.67ZM59.9602 58.03C59.3902 58.03 58.9202 57.56 58.9202 56.99V54.29L61.4002 52.57L67.3802 58.02C67.3802 58.02 67.3202 58.02 67.2802 58.02H59.9602V58.03ZM68.3202 49.67V56.99C68.3202 57.08 68.3002 57.17 68.2802 57.25L61.8402 51.38C61.6402 51.19 61.3302 51.18 61.1102 51.33L58.9202 52.85V49.66C58.9202 49.09 59.3902 48.62 59.9602 48.62H67.2802C67.8502 48.62 68.3202 49.09 68.3202 49.66V49.67Z",
    fill: "black"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M65.8002 52.9598C66.8002 52.9598 67.6102 52.1498 67.6102 51.1498C67.6102 50.1498 66.8002 49.3398 65.8002 49.3398C64.8002 49.3398 63.9902 50.1498 63.9902 51.1498C63.9902 52.1498 64.8002 52.9598 65.8002 52.9598ZM65.8002 50.5198C66.1502 50.5198 66.4302 50.7998 66.4302 51.1498C66.4302 51.4998 66.1502 51.7798 65.8002 51.7798C65.4502 51.7798 65.1702 51.4998 65.1702 51.1498C65.1702 50.7998 65.4502 50.5198 65.8002 50.5198Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarketing);
export default __webpack_public_path__ + "static/media/marketing.cc01f84e7078ac6ea392a018a0d7b196.svg";
export { ForwardRef as ReactComponent };